import { useNavigate } from 'react-router-dom';
import { Bell, X, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useOrderNotifications } from '@/hooks/useOrderNotifications';
import { displayCustomerName } from '@/lib/customerName';

export function OrderNotificationProvider({ children }) {
  const navigate = useNavigate();
  const { 
    newOrder, 
    showBanner, 
    dismissBanner, 
    clearNotification 
  } = useOrderNotifications();

  const handleViewOrder = () => {
    if (newOrder) {
      navigate(`/orders/${newOrder.orderId}`);
      clearNotification();
    }
  };

  return (
    <>
      {/* Single compact notification - Light Pink Theme */}
      {showBanner && newOrder && (
        <div className="fixed top-4 right-4 z-50 animate-in slide-in-from-right duration-300">
          <div className="bg-pink-50 border border-pink-200 text-pink-900 rounded-xl shadow-lg overflow-hidden max-w-sm">
            <div className="px-4 py-3 flex items-center gap-3">
              {/* Bell icon */}
              <div className="bg-pink-100 p-2 rounded-full flex-shrink-0">
                <Bell className="w-4 h-4 text-pink-600 animate-pulse" />
              </div>
              
              {/* Content */}
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-sm">🎂 New Order!</p>
                <p className="text-pink-700 text-xs truncate">
                  {displayCustomerName(newOrder.customerName || 'New Customer')}
                </p>
              </div>
              
              {/* Actions */}
              <div className="flex items-center gap-1 flex-shrink-0">
                <Button
                  onClick={handleViewOrder}
                  size="sm"
                  className="bg-pink-600 text-white hover:bg-pink-700 text-xs px-3 py-1 h-7 font-semibold"
                >
                  View <ArrowRight className="w-3 h-3 ml-1" />
                </Button>
                <button
                  onClick={dismissBanner}
                  className="p-1 hover:bg-pink-100 rounded-full transition-colors"
                >
                  <X className="w-4 h-4 text-pink-600" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {children}
    </>
  );
}

export default OrderNotificationProvider;